/**
 * TODO: Can we get allocation IDs?
 * @param proctorGroupsString - Comma-separated string of all proctor groups
 * @param testsToInclude - Array of test names to filter for (e.g., ['test_name_one', 'test_name_two'])
 * @returns Filtered array of proctor groups in format: "testName:groupValue:allocationId"
 *
 * @example
 * filterProctorGroups("test_a:control:123,test_b:test_1:456,test_c:control:789", ["test_a", "test_b"])
 * // Returns: ["test_a:control:123", "test_b:test_1:456"]
 */
export function getWebToAppPromoProctorGroups(
  proctorGroupsString?: string | null,
  testsToInclude?: string[],
): string[] {
  if (!testsToInclude || testsToInclude.length === 0 || !proctorGroupsString) {
    return [];
  }

  const allGroups = proctorGroupsString
    .split(",")
    .map((group) => group.trim())
    .filter((group) => group.length > 0);

  return allGroups.filter((group) => {
    // Check if this group matches any of the tests we want to include
    return testsToInclude.some((testName) => group.startsWith(`${testName}:`));
  });
}
